import { setAttributes } from "../../utilities/index.js";
function calculateIndicatorGroupSvgAttributes({
  id,
  isRtl,
  numIndicators,
  overlapIndicators
}) {
  const diameter = 24;
  const maskDiameter = 30;
  const radius = diameter / 2;
  const circleOffset = overlapIndicators ? -3 : 6;
  const maskRadius = maskDiameter / 2;
  const maskRadiusDiff = maskRadius - radius;
  const groupWidth = numIndicators * diameter - (numIndicators - 1) * -circleOffset;
  const iterable = Array.from(new Array(numIndicators));
  return {
    // `container` refers to the svg node
    container: {
      viewBox: `0 0 ${groupWidth} ${diameter}`
    },
    // the number of `indicator` svgs corresponds with the value of `numIndicators`
    indicators: iterable.map((_, i) => ({
      // `circle` refers to the circle node inside the indicator svg
      circle: {
        cx: isRtl ? (numIndicators - i) * diameter + (numIndicators - 1 - i) * circleOffset - radius : (i + 1) * diameter + i * circleOffset - radius,
        cy: radius,
        r: radius
      },
      container: {
        mask: `url(#mask-${id}-${i})`,
        viewBox: void 0
        // Override any viewBox attribute set on the individual indicator
      }
    })),
    // there will be one `mask` definition for each `indicator`,
    // which controls what is shown and hidden for its corresponding indicator svg
    masks: iterable.map((_, i) => ({
      container: {
        id: `mask-${id}-${i}`
      },
      // `rectHidden` refers to a circular mask (#000) which is placed concentrically with the circle next to this one,
      // such that it looks like a transparent stroke for that circle overlaid this circle
      rectHidden: circleOffset < 0 && i !== numIndicators - 1 ? {
        height: maskDiameter,
        rx: maskRadius,
        width: maskDiameter,
        x: isRtl ? (numIndicators - i - 1) * (diameter + circleOffset) - diameter - circleOffset - maskRadiusDiff : i * (diameter + circleOffset) + diameter + circleOffset - maskRadiusDiff,
        y: (maskRadius - radius) * -1
      } : void 0,
      // `rectVisible` refers to a circular mask (#fff) placed on top of this circle, through which this circle is visible
      rectVisible: {
        height: diameter,
        width: diameter,
        x: isRtl ? (numIndicators - 1 - i) * (diameter + circleOffset) : i * (diameter + circleOffset)
      }
    }))
  };
}
function initIndicatorGroups() {
  const xmlns = "http://www.w3.org/2000/svg";
  const indicatorGroups = Array.from(document.querySelectorAll(".tds-indicator-group"));
  indicatorGroups.forEach((indicatorGroup) => {
    const id = indicatorGroup.id;
    if (!id) {
      console.warn(
        "Every tds-indicator-group should have a unique `id` attribute to prevent collisions. Without an `id` you may notice issues with rendering."
      );
    }
    const isRtl = getComputedStyle(indicatorGroup).direction === "rtl";
    const overlapIndicators = indicatorGroup.classList.contains("tds-indicator-group--overlap");
    const indicators = Array.from(indicatorGroup.querySelectorAll(".tds-indicator"));
    const svgAttributes = calculateIndicatorGroupSvgAttributes({
      id,
      isRtl,
      numIndicators: indicators.length,
      overlapIndicators
    });
    setAttributes(indicatorGroup, svgAttributes.container);
    const defs = document.createElementNS(xmlns, "defs");
    indicators.forEach((indicator, i) => {
      const containerAttrs = svgAttributes.indicators[i]?.container;
      const circleAttrs = svgAttributes.indicators[i]?.circle;
      const maskAttrs = svgAttributes.masks[i]?.container;
      const rectVisibleAttrs = svgAttributes.masks[i]?.rectVisible;
      const rectHiddenAttrs = svgAttributes.masks[i]?.rectHidden;
      setAttributes(indicator, containerAttrs);
      const mask = document.createElementNS(xmlns, "mask");
      setAttributes(mask, maskAttrs);
      const rectVisible = document.createElementNS(xmlns, "rect");
      rectVisible.setAttribute("fill", "#fff");
      setAttributes(rectVisible, rectVisibleAttrs);
      mask.append(rectVisible);
      if (rectHiddenAttrs) {
        const rectHidden = document.createElementNS(xmlns, "rect");
        rectHidden.setAttribute("fill", "#000");
        setAttributes(rectHidden, rectHiddenAttrs);
        mask.append(rectHidden);
      }
      defs.append(mask);
      const circle = document.createElementNS(xmlns, "circle");
      circle.setAttribute("fill", "var(--tds-status-color--background-color)");
      setAttributes(circle, circleAttrs);
      indicator.append(circle);
    });
    indicatorGroup.prepend(defs);
  });
}
export {
  calculateIndicatorGroupSvgAttributes,
  initIndicatorGroups
};
